import { render } from "./UserImage.vue?vue&type=template&id=1cf7475c&scoped=true"
import script from "./UserImage.vue?vue&type=script&lang=js"
export * from "./UserImage.vue?vue&type=script&lang=js"

import "./UserImage.vue?vue&type=style&index=0&id=1cf7475c&lang=scss&scoped=true"

import exportComponent from "/home/forge/hike.marketing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cf7475c"]])

export default __exports__